export default "__VITE_PUBLIC_ASSET__359483e5__"